import { styled } from '@mui/system';
import MuiCheckIcon from '@mui/icons-material/Check';

const CheckIconStyled = styled(MuiCheckIcon)`
  color: #00a650;
  height: 19px;
  width: 19px;
`;

const CheckCircleDiv = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #00a650;
  border-radius: 100px;
  width: 32px;
  height: 32px;
`;

export const CheckIcon = () => {
  return (
    <CheckCircleDiv>
      <CheckIconStyled />
    </CheckCircleDiv>
  );
};
